import noImage from "../assets/no-image.jpg";

export const SERVICE_IMAGE_FALLBACK = noImage;

export function isValidServiceImage(src: unknown): src is string {
  if (src === false || src == null) return false;
  if (typeof src !== "string") return false;
  const trimmed = src.trim();
  return trimmed.length > 0 && trimmed.toLowerCase() !== "false";
}

export function resolveServiceImageSrc(src: unknown): string {
  return isValidServiceImage(src) ? src.trim() : SERVICE_IMAGE_FALLBACK;
}
